import { Image } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import '../../../assets/styles/quittanceIndemnite.css';
import barre from "../../../assets/img/barre.png";
import entete from '../../../assets/img/entete_pool.png'
import entfoot from "../../../assets/img/footer.png";
import { frenchDate, frenchDateOnly, numberToWordsFrench } from "../../../variables/functions";
import { displayNumbers } from "../../../variables/numbersFunctions";
import { getCompagnieLogo } from "../../../hooks/useFilesHooks";
import { DocumentFooter } from "../../../components/docs/DocumentFooter";

const styles = {
    fontFamily: "Calibri, Arial, sans-serif",
    fontSize: "12px",
    color: "black",
    stamp: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%) rotate(-45deg)",
        color: "red",
        fontSize: "72px",
        fontWeight: "bold",
        opacity: 0.5,
        zIndex: 1000,
        pointerEvents: "none",
        border: "5px solid red",
        padding: "20px",
        textAlign: "center",
    },
};

// Ajouter les styles d'impression
const printStyles = `
@media print {
    @page {
        size: A4 portrait;
        margin: 10mm;
    }
    
    .quittance-container {
        page-break-after: avoid;
        page-break-inside: avoid;
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    
    .quittance-content-wrapper {
        flex-grow: 1;
    }
    
    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        color-adjust: exact !important;
    }
    
    body {
        margin: 0;
        padding: 0;
    }
}
`;


const QuittanceIndemnite = React.forwardRef((props, ref) => {
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
    useEffect(() => {
        if (props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL") {
            getCompagnieLogo(props?.sinistre?.contrat?.organisme?.code)
                .then(async (response) => {
                    const imageBytes = await response.arrayBuffer();
                    var blob = new Blob([imageBytes], { type: "image/png" });
                    var imageUrl = URL.createObjectURL(blob);
                    setLogoPreviewUrl(imageUrl);
                    var file = new File(
                        [blob],
                        props?.contrat?.organisme?.logo?.split("/")[1],
                        {
                            type: "image/png",
                        }
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, []);
    return (
        <div className="quittance-container" ref={ref} style={{ fontFamily: "Calibri, Arial, sans-serif" }}>
            <style>{printStyles}</style>
            <div style={{ flexShrink: 0 }}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 0px",
                    }}
                >
                    {props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL" && (
                        <Image
                            src={logoPreviewUrl}
                            style={{
                                width: "100%",
                                height: "105px",
                            }}
                        />
                    )}

                    <Image
                        src={entete}
                        style={{
                            width: "100%",
                            height: "105px",
                        }}
                    />
                </div>
                <Image
                    src={barre}
                    style={{
                        width: "109%",
                        height: "5px",
                        paddingTop: "-10px",
                    }}
                />
            </div>
            <div className="quittance-content-wrapper" style={{ padding: "20px 40px" }}>
                <div className="quittance-text-block" style={{
                    width: "100%", borderCollapse: "collapse", fontFamily: "Calibri, Arial, sans-serif", fontSize: "22px",
                    WebkitTextStroke: "0.5px black",
                }}>
                    <p style={{ textAlign: "center", fontSize: "22px", border: "1px solid black" }}><b>QUITTANCE</b></p>
                </div>
                <br />
                <table className="quittance-data-table" border={1} style={{ width: "100%", borderCollapse: "collapse", fontFamily: "Calibri, Arial, sans-serif", fontSize: "12px" }}>
                    <tr>
                        <td style={{ padding: "6px", fontWeight: "bold", textAlign: "center", border: "1px solid black" }}>
                            {props?.sinistre?.contrat?.organisme?.raisonSociale.toUpperCase()}
                        </td>
                        <td style={{ padding: "6px", fontWeight: "bold", textAlign: "center", border: "1px solid black" }}>
                            N° SINISTRE
                        </td>
                        <td style={{ padding: "6px", fontWeight: "bold", textAlign: "center", border: "1px solid black" }}>
                            N° POLICE
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "6px", textAlign: "center", border: "1px solid black" }}>SIEGE</td>
                        <td style={{ padding: "6px", textAlign: "center", border: "1px solid black" }}>
                            {props?.sinistre?.numSinistre || props?.sinistre?.numeroSinistreM}
                        </td>
                        <td style={{ padding: "6px", textAlign: "center", border: "1px solid black" }}>
                            {props?.sinistre?.contrat?.numeroPoliceP
                                ? props?.sinistre?.contrat?.numeroPoliceP
                                : props?.sinistre?.contrat?.numeroPoliceM}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "6px", fontWeight: "bold", textAlign: "center", border: "1px solid black" }}>
                            PAIEMENT EN FCFA
                        </td>
                        <td style={{ padding: "6px", fontWeight: "bold", textAlign: "center", border: "1px solid black" }}>
                            SURVENU LE
                        </td>
                        <td style={{ padding: "6px", fontWeight: "bold", textAlign: "center", border: "1px solid black" }}>
                            ASSURE
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "6px", textAlign: "center", border: "1px solid black" }}>
                            {displayNumbers(Math.trunc(props?.decaissement?.montantGlobal))}
                        </td>
                        <td style={{ padding: "6px", textAlign: "center", border: "1px solid black" }}>
                            {frenchDate(props?.sinistre?.dateSinistre)}
                        </td>
                        <td style={{ padding: "6px", textAlign: "center", border: "1px solid black" }}>
                            {props?.sinistre?.contrat?.souscripteur?.prenom
                                ? `${props?.sinistre?.contrat?.souscripteur?.nom} ${props?.sinistre?.contrat?.souscripteur?.prenom}`
                                : props?.sinistre?.contrat?.souscripteur?.nom}
                        </td>
                    </tr>
                </table>
                <br />
                <div className="quittance-text-block" style={{ fontSize: "12px", lineHeight: "1.6", fontFamily: "Calibri, Arial, sans-serif" }}>
                    <p style={{ marginBottom: "8px", fontSize: "14px" }}>
                        Je soussigné :{" "}
                        <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                            {props?.decaissement?.beneficiaire?.prenom
                                ? `${props?.decaissement?.beneficiaire?.nom} ${props?.decaissement?.beneficiaire?.prenom}`
                                : props?.decaissement?.beneficiaire?.nom}
                        </span>
                    </p>
                    {props?.decaissement?.representant && (
                        <p style={{ marginBottom: "8px", fontSize: "14px" }}>
                            Représenté par :{" "}
                            <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                                {props?.decaissement?.representant}
                            </span>
                        </p>
                    )}
                    <p style={{ marginBottom: "8px", fontSize: "14px" }}>
                        Demeurant à :{" "}
                        <span style={{ fontWeight: "bold", fontSize: "14px" }}>
                            {props?.sinistre?.contrat?.souscripteur?.adresse}
                        </span>
                    </p>
                    <p style={{ marginBottom: "8px" }}>
                        <b style={{ fontWeight: "bold", fontSize: "14px" }}>
                            Reconnais avoir reçu du {props?.sinistre?.contrat?.organisme?.raisonSociale.toUpperCase()},
                        </b>
                    </p>
                    <p style={{ marginBottom: "8px", fontSize: "14px" }}>
                        La somme de{" "}
                        <span style={{ fontWeight: "bold", fontSize: "14px", textTransform: "uppercase" }}>
                            {numberToWordsFrench(props?.decaissement?.montantGlobal)} FRANCS CFA
                        </span>
                    </p>
                    <p style={{ marginBottom: "16px", fontSize: "14px" }}>
                        Réprésentant les frais et honoraires relatifs aux {props?.decaissement?.motifReglement}.
                    </p>
                    <p style={{ marginBottom: "16px", fontSize: "14px" }}>
                        Dont quittance sans aucune réserve.
                    </p>
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", fontFamily: "Calibri, Arial, sans-serif" }}>
                    <div className="quittance-text-block" style={{ width: "60%" }}>
                        <p style={{ marginBottom: "6px" }}>
                            <b style={{ fontWeight: "bold", fontSize: "13px" }}>
                                Chèque N° {props?.decaissement?.numeroCheque}
                            </b>
                        </p>
                        <p style={{ marginBottom: "6px" }}>
                            <b style={{ fontWeight: "bold", fontSize: "13px" }}>
                                Du{" "}
                                {props?.decaissement?.dateEmissionCheque
                                    ? frenchDateOnly(props?.decaissement?.dateEmissionCheque)
                                    : ""}
                            </b>
                        </p>
                        <p style={{ marginBottom: "6px" }}>
                            <b style={{ fontWeight: "bold", fontSize: "13px" }}>
                                {props?.decaissement?.banque ? props?.decaissement?.banque : ""}
                            </b>
                        </p>
                        <p style={{ marginTop: "20px" }}>
                            <b style={{ fontWeight: "bold", fontSize: "13px" }}>Le ....................................</b>
                        </p>
                    </div>
                    <div className="quittance-text-block" style={{ width: "35%", textAlign: "right" }}>
                        <p style={{ marginBottom: "6px" }}>
                            <b style={{ fontWeight: "bold", fontSize: "13px" }}>
                                A Lomé le, {props?.decaissement?.dateImpressionQuittance
                                    ? frenchDateOnly(props?.decaissement?.dateImpressionQuittance)
                                    : frenchDateOnly(new Date().toISOString())}
                            </b>
                        </p>
                    </div>
                </div>
                <br />
                <br />
                <br />
            </div>
            <DocumentFooter />
        </div>
    );
});

QuittanceIndemnite.propTypes = {
    decaissement: PropTypes.object,
    sinistre: PropTypes.object,
};

export default QuittanceIndemnite;